var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m18.2426407 18.2426407c1.1186051-1.1186051 1.7573593-2.6287897 1.7573593-4.2426407 0-3.3137085-2.6862915-6-6-6s-6 2.6862915-6 6 2.6862915 6 6 6c1.613851 0 3.1240356-.6387542 4.2426407-1.7573593zm6.9644661 5.5502525c.942809.9428091-.4714045 2.3570226-1.4142136 1.4142136l-4.8871495-4.8871495c-1.3853079 1.0771814-3.0986861 1.6800427-4.9057437 1.6800427-4.418278 0-8-3.581722-8-8s3.581722-8 8-8 8 3.581722 8 8c0 1.8070576-.6028613 3.5204358-1.6800427 4.9057437z","fill":"none"}));
}

Search.defaultProps = {"height":"32","viewBox":"0 0 32 32","width":"32"};

module.exports = Search;

Search.default = Search;
